/* eslint-disable no-nested-ternary -- Reason: legacy suppression retained until the owning code is migrated or cleaned up. */
import { React, useRef, useState } from 'react';
import { Avatar, Col, Dropdown, Select, Space, Typography, message } from 'antd';
import { useLocation, useNavigate } from 'react-router';

import PersonImg from '../../../../resources/images/person.svg';
import { useManagementStore, useUserState } from '../../../../store';
import { getCookie } from '../../../../utilities/cookie';
import Logo from '../logo';

import './styles.scss';

const { Text } = Typography;

export default function Header() {
    const { pathname } = useLocation();
    const isAdminRoute = pathname.startsWith('/admin') && !pathname.startsWith('/admin/u/');
    const { logoutUser, getUser, resetSiteConfigs } = useUserState();
    const logoutPending = useRef(false);
    const [logoutBusy, setLogoutBusy] = useState(false);
    const { company, setCompany } = useManagementStore();
    const { viewAs, setViewAs } = useManagementStore((state) => state);
    const isViewAsActive =
        JSON.stringify(viewAs?.newUser?.token || null) !==
        JSON.stringify(viewAs?.mainUser?.token || null);
    const user = getUser();

    const navigate = useNavigate();
    const userFromCookie = JSON.parse(getCookie('user'));

    const handleLogout = async () => {
        if (logoutPending.current) return;
        logoutPending.current = true;
        setLogoutBusy(true);
        try {
            const result = await logoutUser();
            await resetSiteConfigs();
            window.location.replace(result.loginUrl);
        } catch {
            message.error('Could not sign out. Please try again.');
        } finally {
            logoutPending.current = false;
            setLogoutBusy(false);
        }
    };

    const handleChange = (e) => {
        if (isViewAsActive) {
            setViewAs({ token: user?.token, id: user?.id }, { token: user?.token, id: user?.id });
        }

        setCompany(e);
    };

    const basicMeasureOptions = [
        {
            key: 'Settings',
            label: 'Settings',
            icon: <span className="tt-person" style={{ fontSize: 16 }} />,
            onClick: () => navigate('/settings/1')
        },
        {
            key: 'Logout',
            label: (
                <span style={{ color: '#e57373' }}>{logoutBusy ? 'Signing out…' : 'Logout'}</span>
            ),
            disabled: logoutBusy,
            icon: <span className="tt-logout" style={{ fontSize: 16, color: '#e57373' }} />,
            onClick: () => handleLogout()
        }
    ];

    const companyOptions = [
        {
            value: 'Personal',
            label: 'Personal'
        },
        {
            value: 'Trading Terminal',
            label: 'Trading Terminal'
            // onClick: () => handleLogout()
        },
        {
            value: 'Bear Bull Traders',
            label: 'Bear Bull Traders'
            // onClick: () => navigate('settings/1')
        },
        {
            value: 'Peak Capital Trading',
            label: 'Peak Capital Trading'
            // onClick: () => handleLogout()
        }
    ];
    const renderContent = () => (
        <>
            <Col span={8}>
                <div className="align-start">
                    <div className="logo-and-company">
                        <Logo />
                        {user.role === 'admin' && !isAdminRoute && (
                            <Select
                                // mode='single'
                                onChange={handleChange}
                                options={companyOptions}
                                value={company}
                                showSearch={false}
                                dropdownRender={(menu) => <div className="custom-drop">{menu}</div>}
                                dropdownStyle={{
                                    width: 190,
                                    backgroundColor: '#E0E3EB',
                                    padding: 0
                                }}
                                //   tagRender={(tag) => (
                                //       <span className={tag.value && filter.accounts.indexOf(tag.value) < 1 ? 'custom-select-input' : ''}>
                                //           {tag.label}
                                //           {tag.value && filter.accounts.indexOf(tag.value) < filter.accounts.length - 1 ? ',\u00A0' : ''}
                                //       </span>
                                //   )}
                            />
                            //   <Dropdown menu={{ items: companyOptions, selectable: true, defaultSelectedKeys: 'Personal', onSelect: setCompany }} trigger={['click']}>
                            //       <Button className='button-company'>{company} <DownOutlined /></Button>
                            //   </Dropdown>)
                        )}
                    </div>
                </div>
            </Col>
            <Col span={8} offset={8}>
                <Space size={24} className="align-end">
                    <Dropdown menu={{ items: basicMeasureOptions, selectable: false }}>
                        <div className="user-dropdown-button" onClick={(e) => e.preventDefault()}>
                            <Avatar
                                className="user-avatar"
                                size={32}
                                src={userFromCookie?.avatar || PersonImg}
                            />
                            <Text strong className="user-name-text" style={{ padding: 5 }}>
                                Hi, {userFromCookie?.name || ''}
                            </Text>
                            <span
                                className={`down-icon tt-Chevron_down ${
                                    userFromCookie?.darkMode ? 'dark' : ''
                                }`}
                            />
                        </div>
                    </Dropdown>
                </Space>
            </Col>
        </>
    );

    return (
        <>
            <div className="header-container">{renderContent()}</div>
        </>
    );
}
